import { writable } from "svelte/store";

const storedKey = localStorage.getItem("key");
export const key = writable(storedKey);
key.subscribe(value => {
    if (value) localStorage.setItem("key", value);
    else localStorage.removeItem("key");
});
